import React, { Component } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PaymentIcon from '@material-ui/icons/Payment';

export default class ListPedidos extends Component {

  state = {
    isExpanded: false,
    isMobile: window.innerWidth <= 768
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  toggleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'pendente':
        return '#ff9800';
      case 'em preparo':
        return '#2196f3';
      case 'saiu para entrega':
        return '#9c27b0';
      case 'entregue':
        return '#4caf50';
      case 'cancelado':
        return '#f44336';
      default:
        return '#757575';
    }
  }

  formatarAdicionais = (item) => {
    // Verifica diferentes possíveis campos de adicionais (incluindo o campo com erro de digitação)
    const possiveisAdicionais = item.Adicionais || item.adicionais || item.adicional || item.Adicional || 
                               item.observacoes || item.Observacoes || item.ingredientes || item.Ingredientes ||
                               item.complementos || item.Complementos || item.extras || item.Extras ||
                               item.personalizacoes || item.Personalizacoes || item.adcionais; // CAMPO COM ERRO DE DIGITAÇÃO
    
    // Se não existir, for null, "null" ou string vazia, retorna null
    if (!possiveisAdicionais || 
        possiveisAdicionais === null || 
        possiveisAdicionais === 'null' || 
        possiveisAdicionais === undefined ||
        possiveisAdicionais.toString().trim() === '') {
      
      // Como último recurso, vamos verificar se há algum campo que possa conter informações de personalização
      // Para pizzas "MONTE SUA PIZZA", pode haver outros campos
      const camposItem = Object.keys(item);
      const camposSuspeitos = camposItem.filter(campo => 
        campo.toLowerCase().includes('sabor') ||
        campo.toLowerCase().includes('borda') ||
        campo.toLowerCase().includes('massa') ||
        campo.toLowerCase().includes('tamanho') ||
        campo.toLowerCase().includes('extra') ||
        campo.toLowerCase().includes('molho') ||
        campo.toLowerCase().includes('queijo')
      );
      
      if (camposSuspeitos.length > 0) {
        const valores = camposSuspeitos.map(campo => `${campo}: ${item[campo]}`).filter(val => 
          val && !val.includes('null') && !val.includes('undefined')
        );
        return valores.length > 0 ? valores.join(', ') : null;
      }
      
      return null;
    }
    
    // Se for uma string, retorna formatada
    if (typeof possiveisAdicionais === 'string') {
      const textoLimpo = possiveisAdicionais.trim();
      // Verifica se não é "null" ou variações
      if (textoLimpo.toLowerCase() === 'null' || 
          textoLimpo === '' || 
          textoLimpo === '[]' || 
          textoLimpo === '{}') {
        return null;
      }
      
      // Tenta fazer parse se parecer com JSON
      try {
        if ((textoLimpo.startsWith('[') && textoLimpo.endsWith(']')) ||
            (textoLimpo.startsWith('{') && textoLimpo.endsWith('}'))) {
          const parsed = JSON.parse(textoLimpo);
          return this.formatarAdicionais({adicionais: parsed});
        }
      } catch (e) {
        // Se não conseguir fazer parse, continua com a string
      }
      
      return textoLimpo;
    }
    
    // Se for um array, junta com vírgula
    if (Array.isArray(possiveisAdicionais)) {
      const itensValidos = possiveisAdicionais.filter(item => 
        item && 
        item.toString().trim() !== '' && 
        item.toString().toLowerCase() !== 'null'
      );
      return itensValidos.length > 0 ? itensValidos.join(', ') : null;
    }
    
    // Se for um objeto, tenta extrair informações relevantes
    if (typeof possiveisAdicionais === 'object') {
      // Se tem propriedades como nome, descricao, etc
      if (possiveisAdicionais.nome || possiveisAdicionais.descricao || possiveisAdicionais.item) {
        const partes = [];
        if (possiveisAdicionais.nome) partes.push(possiveisAdicionais.nome);
        if (possiveisAdicionais.descricao) partes.push(possiveisAdicionais.descricao);
        if (possiveisAdicionais.item) partes.push(possiveisAdicionais.item);
        return partes.length > 0 ? partes.join(', ') : null;
      }
      
      // Senão, pega todos os valores válidos
      const valores = Object.values(possiveisAdicionais).filter(item => 
        item && 
        item.toString().trim() !== '' && 
        item.toString().toLowerCase() !== 'null'
      );
      return valores.length > 0 ? valores.join(', ') : null;
    }
    
    return possiveisAdicionais.toString().trim();
  }

  render() {
    const { Data, Valor, Status, Itens, FormaPagamento, Endereco, TaxaEntrega, Subtotal } = this.props;
    const { isExpanded, isMobile } = this.state;
    
    // Calcula valores corretos para exibição
    const valorTotal = parseFloat(Valor || 0);
    const taxaEntrega = (Endereco && TaxaEntrega) ? parseFloat(TaxaEntrega) : 0;
    const subtotal = Subtotal ? parseFloat(Subtotal) : (valorTotal - taxaEntrega);
    
    // Estilos adaptativos
    const adaptiveStyles = {
      cardHeader: {
        ...styles.cardHeader,
        ...(isMobile && {
          flexDirection: 'column',
          gap: '12px',
          padding: '12px 16px',
          alignItems: 'flex-start'
        })
      },
      headerLeft: {
        ...styles.headerLeft,
        ...(isMobile && {
          width: '100%'
        })
      },
      headerRight: {
        ...styles.headerRight,
        ...(isMobile && {
          width: '100%',
          justifyContent: 'space-between'
        })
      },
      statusBadge: {
        ...styles.statusBadge,
        ...(isMobile && {
          fontSize: '11px',
          padding: '4px 10px'
        })
      },
      valorText: {
        ...styles.valorText,
        ...(isMobile && {
          fontSize: '16px'
        })
      },
      expandIcon: {
        ...styles.expandIcon,
        ...(isMobile && {
          fontSize: '20px'
        })
      }
    };
    
    return (
      <div style={styles.cardContainer} className="pedido-card">
        <div style={adaptiveStyles.cardHeader} className="pedido-header" onClick={this.toggleExpand}>
          <div style={adaptiveStyles.headerLeft}>
            <div style={styles.dateContainer}>
              <AccessTimeIcon style={{
                ...styles.icon,
                ...(isMobile && { fontSize: '16px' })
              }} />
              <span style={{
                ...styles.dateText,
                ...(isMobile && { fontSize: '13px' })
              }}>
                {Data ? Data.toString().replace(/\./g, '/') : 'Data não informada'}
              </span>
            </div>
            <div style={{
              ...adaptiveStyles.statusBadge,
              backgroundColor: this.getStatusColor(Status || 'Pendente')
            }} className="status-badge">
              {Status || 'Status não informado'}
            </div>
          </div>
          
          <div style={adaptiveStyles.headerRight}>
            <span style={adaptiveStyles.valorText}>
              € {this.mascaraValor(parseFloat(Valor || 0).toFixed(2))}
            </span>
            {isExpanded ? 
              <ExpandLessIcon style={adaptiveStyles.expandIcon} /> : 
              <ExpandMoreIcon style={adaptiveStyles.expandIcon} />
            }
          </div>
        </div>

        {isExpanded && (
          <div style={{
            ...styles.expandedContent,
            ...(isMobile && { padding: '16px' })
          }} className="expand-animation">
            <div style={{
              ...styles.section,
              ...(isMobile && { marginBottom: '16px' })
            }}>
              <div style={{
                ...styles.sectionHeader,
                ...(isMobile && { marginBottom: '10px' })
              }}>
                <ShoppingCartIcon style={{
                  ...styles.sectionIcon,
                  ...(isMobile && { fontSize: '18px' })
                }} />
                <span style={{
                  ...styles.sectionTitle,
                  ...(isMobile && { fontSize: '15px' })
                }}>Itens do Pedido</span>
              </div>
              <div style={{
                ...styles.itemsList,
                ...(isMobile && { padding: '10px' })
              }}>
                {Itens && Array.isArray(Itens) && Itens.map((item, index) => (
                  <div key={index} style={{
                    ...styles.itemContainer,
                    ...(isMobile && { paddingBottom: '10px', marginBottom: '10px' })
                  }}>
                    <div style={{
                      ...styles.itemRow,
                      ...(isMobile && { 
                        padding: '6px 0',
                        gap: '8px',
                        alignItems: 'flex-start'
                      })
                    }}>
                      <div style={{
                        ...styles.itemInfo,
                        ...(isMobile && { gap: '2px', flex: 1 })
                      }}>
                        <span style={{
                          ...styles.itemName,
                          ...(isMobile && { fontSize: '13px', lineHeight: '1.2' })
                        }}>{item.Produto || 'Produto não informado'}</span>
                        <span style={{
                          ...styles.itemQuantity,
                          ...(isMobile && { fontSize: '11px' })
                        }}>x{item.Quantidade || 1}</span>
                      </div>
                      <span style={{
                        ...styles.itemValue,
                        ...(isMobile && { 
                          fontSize: '13px',
                          minWidth: '70px',
                          textAlign: 'right'
                        })
                      }}>
                        € {this.mascaraValor(parseFloat(item.Valor || 0).toFixed(2))}
                      </span>
                    </div>
                    
                    {/* Exibe adicionais se existir */}
                    {(() => {
                      const adicionaisFormatados = this.formatarAdicionais(item);
                      
                      return adicionaisFormatados && (
                        <div style={{
                          ...styles.adicionaisContainer,
                          ...(isMobile && { 
                            marginTop: '6px',
                            padding: '6px 10px',
                            fontSize: '11px'
                          })
                        }}>
                          <span style={{
                            ...styles.adicionaisLabel,
                            ...(isMobile && { fontSize: '11px', marginBottom: '2px' })
                          }}>Adicionais:</span>
                          <div style={{
                            ...styles.adicionaisText,
                            ...(isMobile && { fontSize: '11px', lineHeight: '1.3' })
                          }}>
                            {adicionaisFormatados}
                          </div>
                        </div>
                      );
                    })()}

                    {/* Aviso para produtos personalizáveis sem adicionais */}
                    {(() => {
                      const produtoPersonalizavel = item.Produto && 
                        (item.Produto.toLowerCase().includes('monte sua') || 
                         item.Produto.toLowerCase().includes('personaliz') ||
                         item.Produto.toLowerCase().includes('escolha'));
                      
                      const temAdicionais = this.formatarAdicionais(item);
                      
                      return produtoPersonalizavel && !temAdicionais && (
                        <div style={{
                          ...styles.adicionaisContainer,
                          backgroundColor: '#ffecb3',
                          borderLeft: '3px solid #ff9800',
                          ...(isMobile && { 
                            marginTop: '6px',
                            padding: '6px 10px',
                            fontSize: '11px'
                          })
                        }}>
                          <span style={{
                            ...styles.adicionaisLabel,
                            color: '#f57600',
                            ...(isMobile && { fontSize: '11px', marginBottom: '2px' })
                          }}>⚠️ Informação:</span>
                          <div style={{
                            ...styles.adicionaisText,
                            ...(isMobile && { fontSize: '11px', lineHeight: '1.3' })
                          }}>
                            Este produto é personalizável, mas os detalhes da personalização não foram registrados ou não estão disponíveis.
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                ))}
              </div>
            </div>

            <div style={{
              ...styles.section,
              ...(isMobile && { marginBottom: '16px' })
            }}>
              <div style={{
                ...styles.sectionHeader,
                ...(isMobile && { marginBottom: '10px' })
              }}>
                <PaymentIcon style={{
                  ...styles.sectionIcon,
                  ...(isMobile && { fontSize: '18px' })
                }} />
                <span style={{
                  ...styles.sectionTitle,
                  ...(isMobile && { fontSize: '15px' })
                }}>Forma de Pagamento</span>
              </div>
              <div style={{
                ...styles.paymentInfo,
                ...(isMobile && { padding: '10px', fontSize: '13px' })
              }}>
                {FormaPagamento || 'Não informado'}
              </div>
            </div>

            <div style={{
              ...styles.totalSection,
              ...(isMobile && { 
                padding: '12px',
                marginTop: '12px'
              })
            }}>
              <div style={{
                ...styles.totalRow,
                ...(isMobile && { marginBottom: '6px' })
              }}>
                <span style={{
                  ...styles.totalLabel,
                  ...(isMobile && { fontSize: '13px' })
                }}>Subtotal:</span>
                <span style={{
                  ...styles.totalValue,
                  ...(isMobile && { fontSize: '13px' })
                }}>
                  € {this.mascaraValor(subtotal.toFixed(2))}
                </span>
              </div>
              {taxaEntrega > 0 && (
                <div style={{
                  ...styles.totalRow,
                  ...(isMobile && { marginBottom: '6px' })
                }}>
                  <span style={{
                    ...styles.totalLabel,
                    ...(isMobile && { fontSize: '13px' })
                  }}>Taxa de entrega:</span>
                  <span style={{
                    ...styles.totalValue,
                    ...(isMobile && { fontSize: '13px' })
                  }}>
                    € {this.mascaraValor(taxaEntrega.toFixed(2))}
                  </span>
                </div>
              )}
              <div style={{
                ...styles.totalRowFinal,
                ...(isMobile && { 
                  paddingTop: '10px',
                  marginTop: '10px'
                })
              }}>
                <span style={{
                  ...styles.totalLabelFinal,
                  ...(isMobile && { fontSize: '15px' })
                }}>Total:</span>
                <span style={{
                  ...styles.totalValueFinal,
                  ...(isMobile && { fontSize: '16px' })
                }}>
                  € {this.mascaraValor(valorTotal.toFixed(2))}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // mdItens() {
  //   return (
  //     <Modal
  //       animationType="fade"
  //       transparent={true}
  //       visible={this.state.isModal}
  //       onRequestClose={() => {
  //         this.setState({ isModal: false })
  //       }}>
  //       <View style={{ flex: 1, marginTop: 0, backgroundColor: 'rgba(0, 0, 0, 0.2)', }}>
  //         <View style={{ flex: 1, marginTop: 100, backgroundColor: '#ffffff', borderTopRightRadius: 0, borderTopLeftRadius: 0 }}>
  //           <View style={{ marginTop: 10, marginLeft: 25 }}>
  //             <TouchableOpacity style={{ height: 40, width: 40 }} onPress={() => { this.setState({ isModal: false }) }}>
  //               <Icon name="close" />
  //             </TouchableOpacity>
  //           </View>
  //           <View><Text style={{ fontSize: 12, fontWeight: 'bold', marginLeft: 15, marginBottom: 15 }}>Itens: </Text></View>
  //           <View style={{width: '95%'}}>
  //             {this.props.Itens.map((i, ix) => (
  //               <ListItem>
  //                 <Body>
  //                   <Text>{i.Produto} x {i.Quantidade}</Text>
  //                 </Body>
  //                 <Right>
  //                   <Text>€ {this.mascaraValor(eval(parseFloat(i.Valor)).toFixed(2))}</Text>
  //                 </Right>
  //               </ListItem>
  //             ))}
  //           </View>
  //         </View>
  //       </View>
  //     </Modal >
  //   );
  // }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }
}

const styles = {
  cardContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: 16,
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    border: '1px solid #e0e0e0'
  },
  cardHeader: {
    padding: '16px 20px',
    cursor: 'pointer',
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  icon: {
    fontSize: '18px',
    color: '#666'
  },
  dateText: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500'
  },
  statusBadge: {
    color: 'white',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignSelf: 'flex-start',
    whiteSpace: 'nowrap'
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  valorText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#991e25'
  },
  expandIcon: {
    fontSize: '24px',
    color: '#666'
  },
  expandedContent: {
    padding: '20px',
    backgroundColor: '#ffffff'
  },
  section: {
    marginBottom: '20px'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px'
  },
  sectionIcon: {
    fontSize: '20px',
    color: '#991e25'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333'
  },
  itemsList: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    padding: '12px'
  },
  itemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '8px 0',
    borderBottom: '1px solid #e9ecef'
  },
  itemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1
  },
  itemName: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
    lineHeight: '1.3'
  },
  itemQuantity: {
    fontSize: '12px',
    color: '#666'
  },
  itemValue: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#991e25',
    textAlign: 'right',
    minWidth: '80px'
  },
  paymentInfo: {
    backgroundColor: '#f8f9fa',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#333'
  },
  totalSection: {
    backgroundColor: '#f8f9fa',
    padding: '16px',
    borderRadius: '8px',
    marginTop: '16px'
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    alignItems: 'center'
  },
  totalLabel: {
    fontSize: '14px',
    color: '#666'
  },
  totalValue: {
    fontSize: '14px',
    color: '#333',
    fontWeight: '500'
  },
  totalRowFinal: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '12px',
    borderTop: '2px solid #991e25',
    marginTop: '12px',
    alignItems: 'center'
  },
  totalLabelFinal: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333'
  },
  totalValueFinal: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#991e25'
  },
  itemContainer: {
    borderBottom: '1px solid #e9ecef',
    paddingBottom: '12px',
    marginBottom: '12px'
  },
  adicionaisContainer: {
    marginTop: '8px',
    padding: '8px 12px',
    backgroundColor: '#e8f5e8',
    borderRadius: '6px',
    borderLeft: '3px solid #4caf50',
    fontSize: '12px'
  },
  adicionaisLabel: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#2e7d32',
    display: 'block',
    marginBottom: '4px'
  },
  adicionaisText: {
    fontSize: '12px',
    color: '#333',
    lineHeight: '1.4',
    wordBreak: 'break-word'
  }
};
